"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var Utils = _interopRequireWildcard(require("./utilityFunctions"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Core Content Component Template
 * Dharma Adusumilli <dadusumilli@svb.com> (svb.com)
 * Example template to show loading content from a file within a file-system
 */
// Helper function to load file content over API get call
var APIContentComponent = function APIContentComponent(props) {
  var fileData;

  if (props.fileURL && !props.token) {
    fileData = Utils.getFileContent(props.fileURL);
  }

  if (props.fileURL && props.token) {
    fileData = Utils.getFileContent(props.fileURL, props.token);
  }

  if (!fileData) {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, "SVB Portal - Core Content Component"), /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": "loading"
    }, "Loading..."));
  }

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, "SVB Portal - Core Content Component"), /*#__PURE__*/_react.default.createElement("h2", null, "Loading content from file at: ", props.fileURL), fileData.type === 'success' ? /*#__PURE__*/_react.default.createElement("div", {
    className: "response"
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    rows: 50,
    cols: 75,
    value: JSON.stringify(fileData.response, null, 2),
    disabled: true
  })) : /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "file-response-error",
    className: "error"
  }, /*#__PURE__*/_react.default.createElement("span", null, fileData.response))));
};

var _default = APIContentComponent;
exports.default = _default;